'use client';

import { useBreakpoint } from '@pie/amber';
import { useRenderMode, RenderMode } from '@upms/use-render-mode';
import { MobileNavigation } from './MobileNavigation';
import { DesktopNavigation } from './DesktopNavigation';

export function Navigation() {
  const isDesktop = useBreakpoint('md');
  const renderMode = useRenderMode();

  // avoid rendering a navigation until breakpoints can be calculated
  if (renderMode === RenderMode.server) {
    return null;
  }

  if (!isDesktop) {
    return <MobileNavigation />;
  }

  return <DesktopNavigation />;
}
